var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteGray = function SvgDeleteGray(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6576 6.4H14.2576L14.0576 5.8C13.9576 5.4 13.5576 5.2 13.2576 5.2H12.4576C12.0576 5.2 11.7576 5.4 11.6576 5.8L11.4576 6.4H10.0576L10.3576 5.3C10.6576 4.5 11.2576 4 12.0576 4H13.6576C14.3576 4 15.0576 4.5 15.2576 5.1L15.6576 6.4Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5572 8.8999L17.6572 18.7999C17.5572 19.4999 17.0572 20.0999 16.3572 20.0999H9.45723C8.75723 20.0999 8.25723 19.5999 8.15723 18.7999L7.15723 8.8999H18.5572Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5576 8.8999L17.6576 18.7999C17.5576 19.4999 17.0576 20.0999 16.3576 20.0999H10.3576C9.65762 20.0999 9.15762 19.5999 9.05762 18.7999L8.05762 8.8999H18.5576Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6572 8.8999H7.05723C6.85723 8.8999 6.65723 8.6999 6.65723 8.3999V8.2999C6.65723 7.1999 7.55723 6.3999 8.55723 6.3999H17.1572C18.2572 6.3999 19.1572 7.2999 19.1572 8.3999V8.4999C19.0572 8.6999 18.8572 8.8999 18.6572 8.8999Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.057 17.5998C9.75703 17.5998 9.45703 17.2998 9.45703 16.9998V10.8998C9.45703 10.5998 9.75703 10.2998 10.057 10.2998C10.357 10.2998 10.657 10.5998 10.657 10.8998V16.9998C10.657 17.3998 10.357 17.5998 10.057 17.5998Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8578 17.5998C12.5578 17.5998 12.2578 17.2998 12.2578 16.9998V10.8998C12.2578 10.5998 12.5578 10.2998 12.8578 10.2998C13.1578 10.2998 13.4578 10.5998 13.4578 10.8998V16.9998C13.4578 17.3998 13.1578 17.5998 12.8578 17.5998Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6576 17.5998C15.3576 17.5998 15.0576 17.2998 15.0576 16.9998V10.8998C15.0576 10.5998 15.3576 10.2998 15.6576 10.2998C15.9576 10.2998 16.2576 10.5998 16.2576 10.8998V16.9998C16.2576 17.3998 15.9576 17.5998 15.6576 17.5998Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.85742 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DeleteGray.fddd92b4.svg";
export { ForwardRef as ReactComponent };